module.exports = __webpack_public_path__ + "img/s4.cb635e29.jpg";